// Lightweight tracking + UTM capture helper.
// All providers are gated by env vars. If a var is empty, the integration is a no op.

const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];
const STORAGE_KEY = "spt_attribution";

const env = {
  pixel: process.env.REACT_APP_META_PIXEL_ID,
  gtag: process.env.REACT_APP_GA_TAG_ID,
  conversion: process.env.REACT_APP_GADS_CONVERSION_ID,
};

function readStored() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

function writeStored(data) {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch {
    /* ignore */
  }
}

// Capture UTM params + referrer + landing_page on first visit of the session.
// Subsequent visits keep the original first touch attribution.
export function captureAttribution() {
  if (typeof window === "undefined") return null;
  const existing = readStored();
  if (existing) return existing;

  const params = new URLSearchParams(window.location.search);
  const data = {
    utm_source: params.get("utm_source") || null,
    utm_medium: params.get("utm_medium") || null,
    utm_campaign: params.get("utm_campaign") || null,
    utm_content: params.get("utm_content") || null,
    utm_term: params.get("utm_term") || null,
    referrer: document.referrer || null,
    landing_page: window.location.href,
  };
  writeStored(data);
  return data;
}

export function getAttribution() {
  return readStored() || captureAttribution() || {};
}

// Inject Meta Pixel + GA/Google Ads tag scripts only if their IDs are set.
export function initTrackingScripts() {
  if (typeof window === "undefined") return;

  if (env.pixel && !window.__sptPixelLoaded) {
    window.__sptPixelLoaded = true;
    /* eslint-disable */
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = "2.0";
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    /* eslint-enable */
    window.fbq("init", env.pixel);
    window.fbq("track", "PageView");
  }

  if (env.gtag && !window.__sptGtagLoaded) {
    window.__sptGtagLoaded = true;
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(env.gtag)}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;
    gtag("js", new Date());
    gtag("config", env.gtag);
  }
}

export function trackLeadConversion(lead) {
  if (typeof window === "undefined") return;
  try {
    if (env.pixel && window.fbq) {
      window.fbq("track", "Lead", {
        content_name: lead?.zone || "lead",
        currency: "EUR",
      });
    }
    if (env.gtag && window.gtag) {
      window.gtag("event", "generate_lead", {
        currency: "EUR",
        zone: lead?.zone,
      });
      if (env.conversion) {
        window.gtag("event", "conversion", {
          send_to: env.conversion,
          currency: "EUR",
        });
      }
    }
  } catch (e) {
    /* tracking must never break the app */
    console.warn("tracking error", e);
  }
}

export const trackingConfig = env;

export const utmKeys = UTM_KEYS;
